<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M80.876 106.759H46.6797"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M83.0469 27.7712V38.4567C83.0469 46.7992 76.2719 53.5742 67.9293 53.5742C59.584 53.5742 52.8118 46.7992 52.8118 38.4567V27.7712C52.8118 19.4258 59.5868 12.6537 67.9293 12.6537C76.2719 12.6537 83.0469 19.4287 83.0469 27.7712Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.4154 16.4119H66.4438C60.9908 16.4119 56.5703 20.8324 56.5703 26.2853V39.9424C56.5703 45.3954 60.9908 49.8159 66.4438 49.8159H69.4154C74.8684 49.8159 79.2889 45.3954 79.2889 39.9424V26.2853C79.2889 20.8324 74.8684 16.4119 69.4154 16.4119Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.3527 16.4119H70.5065C75.353 16.4119 79.2889 20.3477 79.2889 25.1942H56.5703C56.5703 20.3477 60.5062 16.4119 65.3527 16.4119Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.2897 42.1585C73.5523 42.9085 61.5417 43.3258 61.6235 37.7096C61.7052 32.0933 70.0957 31.583 69.154 33.534C67.0423 37.9069 74.4686 30.8979 79.2897 30.788"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.9455 100.635H32.8282C29.287 100.635 26.4141 97.7624 26.4141 94.2212C26.4141 90.6801 29.287 87.8071 32.8282 87.8071"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.6876 87.7706C21.3822 89.2423 18.0807 45.0767 17.452 28.6453C17.3223 25.2649 19.8738 22.3834 23.243 22.0959C25.476 21.907 27.5482 22.9022 28.8226 24.5713"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.1543 38.5271C18.4954 48.5669 19.6091 61.2175 22.7978 69.4473C39.6831 113.021 81.1027 100.122 81.1027 93.7729C81.1027 80.8883 13.4431 81.331 24.6671 102.964C30.9374 115.051 63.5125 114.935 80.8743 113.032"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M42.876 28.7523C42.876 28.7523 42.7012 31.7832 43.4934 34.5264C44.3928 37.6362 41.1787 36.39 41.1787 36.39C41.1787 36.39 38.6412 41.8596 34.5137 39.8607"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.9954 29.8857C30.9954 29.8857 31.4662 31.9608 32.8816 31.0163C34.2969 30.0746 34.9566 26.7731 37.6886 27.3398C40.4234 27.9065 44.0999 29.2852 45.0416 27.275C45.9833 25.2647 41.0832 16.4034 34.7649 17.441C28.4495 18.4785 19.1596 24.4218 26.6564 34.1289C27.5135 35.2369 28.723 37.4276 28.723 37.9943C28.723 38.561 31.7566 38.1944 29.9551 33.3733C29.9551 33.3733 26.8566 31.2108 29.2953 28.7523C29.6534 28.3914 30.6148 27.9967 30.9926 29.8829L30.9954 29.8857Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M29.4316 38.1945C29.4316 38.1945 30.5368 41.2338 29.9589 43.2609"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M36.0343 40.3004C36.0343 40.3004 35.8651 41.2477 38.0473 43.2608C40.2295 45.2738 52.0597 62.9767 52.3952 65.1589"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M27.4746 50.9324C27.4746 50.9324 33.6124 79.5294 41.236 84.2067C41.236 84.2067 47.3992 78.1648 48.3437 74.2205"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.2324 83.1834C42.2324 83.1834 48.4492 87.5168 57.2513 83.1834C66.0534 78.85 76.5951 64.395 76.5951 64.395C76.5951 64.395 78.5517 63.3518 79.313 67.5696C80.0742 71.7874 85.7242 102.868 87.2467 105.259"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.4219 67.5668C57.4219 67.5668 74.1211 54.1775 77.572 55.1559C83.332 56.7855 92.2441 91.9996 93.3295 92.758"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.25 83.1835C57.25 83.1835 69.4213 78.9572 71.8121 77.3276C71.8121 77.3276 74.0507 91.8757 77.6398 97.8584C81.4347 104.185 83.3321 107.977 83.3321 107.977"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.2539 83.3242C82.2539 83.3242 87.3513 92.8678 88.981 94.7173"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.0488 43.2582C38.0488 43.2582 35.9625 44.1209 34.9785 43.8643"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.5854 107.974C82.5854 107.974 81.8692 114.944 83.3325 115.268C84.7958 115.592 100.46 114.879 102.736 113.579C103.415 113.19 102.981 111.868 101.52 111.332C98.0976 110.077 90.4035 109.082 88.0099 105.394C88.0099 105.394 84.6661 108.479 82.5854 107.974Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.4512 96.6233C89.4512 96.6233 90.4718 103.553 91.9689 103.511C93.466 103.466 108.474 98.9239 110.36 97.1054C110.924 96.5613 110.176 95.3856 108.631 95.2277C105.006 94.8527 97.3032 95.7775 94.075 92.7946C94.075 92.7946 91.5911 96.6064 89.4512 96.6289V96.6233Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M40.6078 32.2205C41.0224 30.9652 40.806 29.7651 40.1244 29.5399C39.4428 29.3148 38.5541 30.1499 38.1395 31.4051C37.7248 32.6604 37.9412 33.8605 38.6228 34.0857C39.3044 34.3108 40.1931 33.4757 40.6078 32.2205Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.1364 31.4025L31.4629 29.1611"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M40.6074 32.2173C40.6074 32.2173 41.9382 31.4222 42.9813 31.8085"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.7064 71.08H26.7635C25.2998 71.08 24.1133 72.2665 24.1133 73.7302V73.733C24.1133 75.1967 25.2998 76.3832 26.7635 76.3832H70.7064C72.1701 76.3832 73.3566 75.1967 73.3566 73.733V73.7302C73.3566 72.2665 72.1701 71.08 70.7064 71.08Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.0877 68.2774C47.5154 69.7463 46.1057 71.703 44.9075 72.2866C44.665 72.405 44.4338 72.467 44.2167 72.4558C42.4095 72.374 27.76 57.0845 27.1425 48.8801C26.5956 41.6117 33.8837 42.5167 35.3667 46.2158L37.2979 49.3819C38.8091 54.0818 47.366 65.7456 48.2061 66.6901C48.4486 66.9608 48.3697 67.5613 48.0934 68.2774H48.0877Z"
            fill="white" />
        <path
            d="M35.3647 46.2158C33.8845 42.5167 26.5936 41.6117 27.1406 48.8801C27.758 57.0873 42.4075 72.374 44.2148 72.4558C44.4318 72.467 44.6659 72.405 44.9055 72.2866"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.2949 49.3817C38.8061 54.0816 47.3629 65.7454 48.2031 66.6899C48.4456 66.9606 48.3666 67.5611 48.0903 68.2772"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.0211 53.1964C71.7327 56.2752 66.3167 57.9443 64.4784 59.0325C63.0518 62.3058 51.1371 74.3023 49.7105 74.3869C48.4418 74.463 45.5322 72.6812 44.9062 72.2865C46.1045 71.7057 47.517 69.749 48.0865 68.2773C49.5977 67.2228 59.474 60.2815 61.9635 57.386C64.9521 56.3598 69.3785 54.7753 73.0211 53.1964Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.9349 48.9842C76.9349 48.9842 75.435 48.192 74.42 48.4683C73.405 48.7446 63.2637 52.7284 62.2938 53.1569C61.6905 53.4248 59.8043 54.4482 60.5881 55.325"
            fill="white" />
        <path
            d="M76.9349 48.9842C76.9349 48.9842 75.435 48.192 74.42 48.4683C73.405 48.7446 63.2637 52.7284 62.2938 53.1569C61.6905 53.4248 59.8043 54.4482 60.5881 55.325"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.0686 49.7821C78.2256 50.7378 75.8601 51.9642 73.0238 53.1963C69.3812 54.7752 64.9548 56.3597 61.9662 57.3859C59.9278 58.0879 58.5548 58.525 58.5548 58.525C58.0557 56.4753 59.7586 55.7197 60.5932 55.3221C64.9773 53.233 74.9861 49.7792 76.94 48.9813C78.8938 48.1835 79.0714 49.7792 79.0714 49.7792L79.0686 49.7821Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
